<div *ngIf="currentUser">
  <p>Market Data status: <b><span style="color: #007bff">{{ currentUser.company.sugarMckayStatus }}</span></b></p>
  <br>
  <div style="width: 70%;">
    <p-table [value]="orderForms">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 35%">Order forms</th>
          <th>Identification number</th>
          <th>Execution date</th>
          <th>End date</th>
        </tr>
      </ng-template>
      <ng-template let-orderForm pTemplate="body">
        <tr>
          <td style="width: 35%">{{ orderForm.name }}</td>
          <td>{{ orderForm.identificationNumber }}</td>
          <td>{{ orderForm.executionDate | date: "MMM dd, y" }}</td>
          <td>{{ orderForm.endDate | date: "MMM dd, y" }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        {{ orderForms?.length }} Order Forms
      </ng-template>
    </p-table>
  </div>
</div>
